import { render, staticRenderFns } from "./CountryItem.vue?vue&type=template&id=02a1145f&scoped=true&"
import script from "./CountryItem.vue?vue&type=script&lang=ts&"
export * from "./CountryItem.vue?vue&type=script&lang=ts&"
import style0 from "./CountryItem.vue?vue&type=style&index=0&id=02a1145f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a1145f",
  null
  
)

export default component.exports